import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon } from 'react-icons/fa';

import { CompanyCodePropTypes } from '../../shared/propTypes/companyCodes';

import {
  sharedActions,
} from './store/actions';

const CompanyCodesAdminColumnRenderer = ({
  showEditCompanyCodeModal,
  value,
}) => {
  const showEditModal = useCallback(() => {
    showEditCompanyCodeModal(value);
  }, [showEditCompanyCodeModal, value]);

  return (
    <div>
      <button
        className="cell-icon-button"
        title="Edit Company Code"
        onClick={showEditModal}
      >
        <PencilIcon size={16} className="cell-icon" />
      </button>
    </div>
  );
};

CompanyCodesAdminColumnRenderer.propTypes = {
  showEditCompanyCodeModal: PropTypes.func.isRequired,
  showDeleteCompanyCodeModal: PropTypes.func.isRequired,
  value: CompanyCodePropTypes.isRequired,
};

export default connect(null, {
  showEditCompanyCodeModal: sharedActions.showModalForAddEdit,
  showDeleteCompanyCodeModal: sharedActions.showModalForRemove,
})(CompanyCodesAdminColumnRenderer);
